// Real-time websocket notifications are disabled (requires Pusher paid plan).
// To re-enable: configure REACT_APP_PUSHER_APP_KEY and related env vars,
// then restore the full Echo initialisation from git history.

const echo = null;

export { echo };
